import { faBarcode, faIdCard, faQrcode } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import useActionPanelStore from 'src/stores/useActionPanelStore';
import { BUREAU_BARCODE_FORMAT, LOCALSTORAGE_KEYS } from 'src/utils/constants';

import useLocalstorage from '../utils/useLocalStorage';

const TravelerQRCodes = ({ options }) => {
  const { closeActionPanel } = useActionPanelStore();
  const [scanMode] = useLocalstorage(LOCALSTORAGE_KEYS.SCAN_MODE, BUREAU_BARCODE_FORMAT.QR);
  const scanIcon = scanMode === BUREAU_BARCODE_FORMAT.BARCODE ? faBarcode : faQrcode;

  return (
    <div className='qr-codes' data-cy='traveler-qr-panel'>
      <span className='qr-codes__title' data-cy='traveler-qr-title'>
        <FontAwesomeIcon icon={faIdCard} className='spacer-right' />
        Travelers:
      </span>
      <div className='container-qr-codes gap30'>
        {options.map(({ key, label, to, dataCy }) => (
          <div key={key} className='container-qr-code'>
            <Link to={to} data-cy={dataCy} onClick={closeActionPanel}>
              <FontAwesomeIcon icon={scanIcon} className='container-qr-code-icon' />
              <p className='container-qr-code-text'>{label}</p>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

TravelerQRCodes.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      to: PropTypes.string.isRequired,
      dataCy: PropTypes.string,
    })
  ).isRequired,
};

export default TravelerQRCodes;
